import { useEffect, useState } from 'react';

import type {
  ChartV2LiveFeed,
  ChartV2LiveUpdate,
} from '../types/chart-v2.types';
import type { LivePerSeries } from '../utils/panes';

export const useLiveFeed = (
  liveFeed: ChartV2LiveFeed | undefined
): Record<string, LivePerSeries> => {
  const [liveBySeries, setLiveBySeries] = useState<
    Record<string, LivePerSeries>
  >({});

  useEffect(() => {
    if (!liveFeed) {
      return undefined;
    }

    const handleUpdate = (update: ChartV2LiveUpdate) => {
      setLiveBySeries(prev => {
        const existing = prev[update.seriesId];

        return {
          ...prev,
          [update.seriesId]: {
            points: existing
              ? [...existing.points, update.point]
              : [update.point],
          },
        };
      });
    };

    return liveFeed.subscribe(handleUpdate);
  }, [liveFeed]);

  return liveBySeries;
};
